/**
 * L2-P1: moved to @miq/shared-models (components/input-props.ts). This shim keeps the old
 * import path working; new code should import from '@miq/shared-models'.
 */
export type { DefaultSelectionValue, FormGroupValue, InputProps, InputPropOption, HintProps, FilterableComponent } from '@miq/shared-models';
export { FilterInputType, Placeholder, InputPropsEnum } from '@miq/shared-models';
